var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goal-list"},[_c('div',{staticClass:"goal-list__main"},[_c('sidebar-switcher',{staticClass:"goal-list__main__sidebar"}),_c('goals')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }